import StrategyCalculator from "./Calculator";
import StrategyPerformanceCharts from "./PerformanceCharts";
import DividerLine from "components/common/divider/line";
import StrategyInfo from "./Info";
import StrategyFAQ from "./FAQ";
import { STRATEGY_TYPE } from "utils/constant/STATUS";

function StrategyPerformance({
  logMock,
  kospiLogMock,
  risk,
  sCode,
  faqAutoExpanded,
  setFaqAutoExpanded,
  realtimeData,
  nasdaqLogMock,
}: {
  logMock: any;
  kospiLogMock: any;
  risk: number;
  sCode: STRATEGY_TYPE;
  faqAutoExpanded: boolean;
  setFaqAutoExpanded: (faqAutoExpanded: boolean) => void;
  realtimeData: any;
  nasdaqLogMock: any;
}) {
  return (
    <div className="flex flex-col">
      <StrategyPerformanceCharts
        logMock={logMock}
        kospiLogMock={kospiLogMock}
        nasdaqLogMock={nasdaqLogMock}
        realtimeData={realtimeData}
      />
      <div className="px-6">
        <div className="w-full h-[1px] bg-gray15" />
      </div>
      <StrategyCalculator logMock={logMock} realtimeData={realtimeData} />
      <DividerLine size="xl" />
      <StrategyInfo risk={risk} sCode={sCode} />
      <DividerLine size="xl" />
      <StrategyFAQ
        faqAutoExpanded={faqAutoExpanded}
        setFaqAutoExpanded={setFaqAutoExpanded}
      />
    </div>
  );
}

export default StrategyPerformance;
